













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListJigyosho',
  components: {
    CtrlSearchCommonComponents,
  },

  props: {
    mukoUmuFlg: {
      type: Number,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'jigyoshoCd',
        width: 17,
      },
      {
        text: '名称',
        sortable: true,
        value: 'jigyoshoMei',
        width: 85,
      },
    ],
    formatColName: 'jigyoshoCd',
  }),
});
